import { useQuery } from '@tanstack/react-query'

import { DefaultApiGetOlInfoSharingConsentRequest } from '@src/api/generated/user-api'
import { getOlInfoSharingConsent } from '@src/api/repositories'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchOlConsent = (
  params: DefaultApiGetOlInfoSharingConsentRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getOlInfoSharingConsent(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_OL_INFO_SHARING_CONSENT,
      params.organizationId,
    ],
  })
}
